import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorMessageStore = defineStore('errorMessage', () => {
  const message = ref<string>()
  const timeout = ref<NodeJS.Timeout>()

  const showErrorMessage = (errorMessage: string) => {
    if (timeout.value != null) {
      clearTimeout(timeout.value)
    }
    message.value = errorMessage
    timeout.value = setTimeout(() => (message.value = undefined), 5000)
  }

  return { message, showErrorMessage }
})
